import { render, staticRenderFns } from "./FrontDesk.vue?vue&type=template&id=f75f2c5e&scoped=true"
import script from "./FrontDesk.vue?vue&type=script&lang=js"
export * from "./FrontDesk.vue?vue&type=script&lang=js"
import style0 from "./FrontDesk.vue?vue&type=style&index=0&id=f75f2c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f2c5e",
  null
  
)

export default component.exports